const HeaderDataAlpha = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "About",
    link: "/about-us",
  },
  {
    title: "Streams",

    // dropdown: [
    //   {
    //     title: "PCM",
    //     link: "/pcm",
    //   },
    //   {
    //     title: "PCB",
    //     link: "/pcb",
    //   },
    //   {
    //     title: "Commerce",
    //     link: "/commerce",
    //   },
    //   {
    //     title: "Arts",
    //     link: "/arts",
    //   },
    //   {
    //     title: "Diploma",
    //     link: "/diploma",
    //   },
    // ],
    megamenu: [
      {
        title: "Degree Courses",
        dropdown: [
          {
            title: "MBA",
            link: "/mba",
          },
          {
            title: "BBA",
            link: "/bba",
          },

          // {
          //   title: "BA LLB",
          //   link: "/ba-llb",
          // },

          {
            title: "LLB / BBA LLB",
            link: "/bba-llb",
          },

          {
            title: "B-Tech",
            link: "/b-tech",
          },
          {
            title: "Diploma",
            link: "/diploma",
          },
        ],
      },
      {
        title: "Medical Courses",
        dropdown: [
          {
            title: "MBBS",
            link: "/mbbs",
          },
          {
            title: "BAMS",
            link: "/bams",
          },
          {
            title: "BHMS",
            link: "/bhms",
          },
          {
            title: "BDS",
            link: "/bds",
          },
          {
            title: "B.sc Nursing",
            link: "/nursing",
          },
          {
            title: "B Pharma/Pharm D",
            link: "/pharmacy",
          },
        ],
      },
      {
        title: ".",
        dropdown: [
          {
            title: "Bio Tech/B.Sc Bio Tech",
            link: "/biotech",
          },
          {
            title: "B.Sc Radiology",
            link: "/radiology",
          },
          {
            title: "B.Sc Microbiology",
            link: "/microbiology",
          },
          {
            title: "Bachelor in Physio Therapy",
            link: "/physio-therapy",
          },
          {
            title: "B.Sc Forensic",
            link: "/forensic",
          },
        ],
      },
    ],
  },

  {
    title: "Medical Counselling",
    link: "medical-counselling",
  },
  {
    title: "Direct Admission",
    megamenu: [{ title: "directAdmission" }],
  },
  {
    title: "Contact Us",
    link: "/contact",
  },

  {
    title: "Locations",

    megamenu: [
      {
        title: "Explore Locations in Counselling India",
        dropdown: [
          {
            title: "Bangalore",
            link: "/top-education-consultant-in-bangalore",
          },

          {
            title: "Chennai",
            link: "/top-education-consultant-in-Chennai",
          },

          {
            title: "Jamshedpur",
            link: "/top-education-consultant-in-Jamshedpur",
          },
          {
            title: "Mumbai",
            link: "/top-education-consultant-in-Mumbai",
          },
          {
            title: "Pune",
            link: "/top-education-consultant-in-Pune",
          },
          {
            title: "Uttar Pradesh",
            link: "/top-education-consultant-in-uttar-pradesh",
          },

          {
            title: "Maharashtra",
            link: "/top-education-consultant-in-maharashtra",
          },

          {
            title: "Puducherry",
            link: "/top-education-consultant-in-puducherry",
          },
          {
            title: "Rajasthan",
            link: "/top-education-consultant-in-rajasthan",
          },
          {
            title: "Tamil Nadu",
            link: "/top-education-consultant-in-tamil-nadu",
          },
        ],
      },
    ],
  },
  {
    title: "MBBS Admission",
    link: "/mbbs-admission-through-management-quota-2026",
  },
];

export default HeaderDataAlpha;

// Direct Admission
